import React, { memo, useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import useMobile from 'commons/hooks/useMobile'
import Transition from './Transition'
import { closeModal } from './actions'
import { ModalEvent } from './types'

function Modal() {
  const isMobile = useMobile()
  const [content, setContent] = useState<ModalEvent | null>()

  const showModal = (event: CustomEvent<ModalEvent>) => {
    setContent(event.detail)
  }

  useEffect(() => {
    window.addEventListener('modal-display', showModal as EventListener)

    return () => {
      window.removeEventListener('modal-display', showModal as EventListener)
    }
  }, [])

  return (
    <Dialog
      onClose={closeModal}
      fullScreen={isMobile}
      open={Boolean(content)}
      TransitionComponent={Transition}
      {...content?.dialogProps}
    >
      {content?.component}
    </Dialog>
  )
}

export default memo(Modal)
